import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { Nullable } from '@src/types/utils';

import { ChatPermissionsModel } from '../types';
import { StoreService } from '../../services';

@Component({
  selector: 'chat-footer',
  templateUrl: './chat-footer.component.html',
  styleUrls: ['./chat-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ChatFooterComponent {
  private readonly store = inject(StoreService);
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() chatId!: string;
  @Input() permissions?: Nullable<ChatPermissionsModel>;
  @Output() textMessageSent = new EventEmitter<void>();

  get footerMessageOptions() {
    return this.store.getFooterMessage(this.chatId);
  }

  onCloseFooterMessage(deleteDraft: boolean) {
    this.store.deleteFooterMessage(this.chatId);

    if (deleteDraft) {
      this.store.deleteDraftMessage(this.chatId);
    }

    this.cdr.markForCheck();
  }
}
